import { mod } from "../utils/utility-functions.js";
const dayMap = {
    SUN: 0,
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
};
export function formatScheduleTime(schedule) {
    const startHour = schedule.startHour.toString().padStart(2, "0");
    const startMinute = schedule.startMinute.toString().padStart(2, "0");
    const stopHour = schedule.stopHour.toString().padStart(2, "0");
    const stopMinute = schedule.stopMinute.toString().padStart(2, "0");
    return `${schedule.day} ${startHour}${startMinute}-${stopHour}${stopMinute}`;
}
export function getTimeUntilSaaScheduleActivation(schedule, _now) {
    const now = new Date(_now);
    const start = new Date(now);
    const dayToSet = mod(dayMap[schedule.day] - now.getUTCDay(), 7);
    start.setUTCDate(now.getUTCDate() + dayToSet);
    start.setUTCHours(schedule.startHour, schedule.startMinute, 0, 0);
    const stop = new Date(start);
    stop.setUTCHours(schedule.stopHour, schedule.stopMinute, 0, 0);
    if (start <= now && now < stop) {
        return 0;
    }
    return start.getTime() - now.getTime();
}
export const saaDisplaySettingCycle = [
    "OFF",
    "BOUNDARY",
    "BOUNDARY_LABEL",
    "BOUNDARY_ALT_LABEL",
];
//# sourceMappingURL=saa.js.map